import { render, staticRenderFns } from "./SerialBookingList.vue?vue&type=template&id=96a0cb4c"
import script from "./SerialBookingList.vue?vue&type=script&lang=js"
export * from "./SerialBookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports